import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'chevron-right-icon',
    templateUrl: './chevron-right-icon.component.svg',
    styleUrl: './chevron-right-icon.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ChevronRightIconComponent {
  size = input<number>(10);
}
